const componentStrings = {
  datepicker: {
    sk: {
      today: 'Dnes',
      yesterday: 'Včera',
      last7days: 'Posledných 7 dní',
      last30days: 'Posledných 30 dní',
      thisMonth: 'Tento mesiac',
      lastMonth: 'Minulý mesiac',
      customRange: 'Vlastný interval',
      apply: 'Potvrdiť',
      cancel: 'Zrušiť',
      showAll: 'Zobraziť všetko'
    },
    cz: {
      today: 'Dnes',
      yesterday: 'Včera',
      last7days: 'Posledních 7 dní',
      last30days: 'Posledních 30 dní',
      thisMonth: 'Tento měsíc',
      lastMonth: 'Minulý měsíc',
      customRange: 'Vlastní interval',
      apply: 'Potvrdit',
      cancel: 'Zrušit',
      showAll: 'Zobrazit všechno'
    },
    en: {
      today: 'Today',
      yesterday: 'Yesterday',
      last7days: 'Last 7 days',
      last30days: 'Last 30 days',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      customRange: 'Custom range',
      apply: 'Apply',
      cancel: 'Cancel',
      showAll: 'Show all'
    }
  },
  sensorChart: {
    sk: {
      temperature: 'Teplota [°C]',
      snowTemperature: 'Teplota snehu [°C]',
      moisture: 'Vlhkosť [%]',
      pressure: 'Tlak [hPa]',
      precipitation: 'Úhrn zrážok [mm/m2]',
      irradiation: 'Intenzita slnečného žiarenia [W/m2]',
      windSpeedAvg: 'Priemerná rýchlosť vetra [m/s]',
      windSpeedMax: 'Max. rýchlosť vetra [m/s]'
    },
    cz: {
      temperature: 'Teplota [°C]',
      snowTemperature: 'Teplota snehu [°C]',
      moisture: 'Vlhkost [%]',
      pressure: 'Tlak [hPa]',
      precipitation: 'Úhrn zrážek [mm/m2]',
      irradiation: 'Intenzita slunečného záření [W/m2]',
      windSpeedAvg: 'Prūměrná rychlost větra [m/s]',
      windSpeedMax: 'Max. rychlost vetra [m/s]'
    },
    en: {
      temperature: 'Temperature [°C]',
      snowTemperature: 'Snow temperature [°C]',
      moisture: 'Moisture [%]',
      pressure: 'Pressure [hPa]',
      precipitation: 'Precipitation [mm/m2]',
      irradiation: 'Solar irradiation [W/m2]',
      windSpeedAvg: 'Wind speed avg. [m/s]',
      windSpeedMax: 'Max. Wind speed [m/s]'
    }
  }
}

export { componentStrings }



//////////////////
// WEBPACK FOOTER
// ./static/localization/componentStrings.js
// module id = 198
// module chunks = 1